// Obtener el modo de compilación
const BUILD_MODE = process.env.VUE_APP_BUILD_MODE;

// Definir si se debe mostrar el menú de puntos de acceso
const showAccessPoints = BUILD_MODE === "1" || BUILD_MODE === "2";

export default [
  {
    name: 'Métricas',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/admin/overview',
    requireSupport: false
  },
  {
    name: 'Socios y Membresías',
    icon: 'nc-icon nc-single-02',
    path: '/customers&memberships',
    requireSupport: false,
    children: [
      // Menú de Socios antiguo - Comentado y oculto
      // {
      //   name: 'Socios',
      //   path: '/customers&memberships/customers'
      // },
      {
        name: 'Gestión de Socios',
        path: '/customers&memberships/socios-v2'
      },
      {
        name: 'Gestión de Membresías',
        path: '/customers&memberships/gestion-membresias'
      },
      // Menú de Membresías - Comentado ya que la funcionalidad se integró en Gestión de Socios
      // {
      //   name: 'Membresías',
      //   path: '/customers&memberships/memberships'
      // },
      // Actualizador Masivo - Oculto desde 0.8.15. Funcionalidad pendiente de corrección
      // y re-implementación. La ruta /customers&memberships/MMU sigue registrada en routes.js.
      // {
      //   name: 'Actualizador Masivo',
      //   path: '/customers&memberships/MMU'
      // }
    ]
  },
  {
    name: 'Registros de Acceso',
    icon: 'nc-icon nc-tap-01',
    path: '/access/dashboard',
    requireSupport: false
  },
  {
    name: 'Planes',
    icon: 'nc-icon nc-credit-card',
    path: '/plans',
    requireSupport: false,
    children: [
      {
        name: 'Biblioteca de Planes',
        path: '/plans/biblioteca'
      },
      {
        name: 'Turnos',
        path: '/plans/turnos'
      }
    ]
  },
  {
    name: 'Sugerencias',
    icon: 'nc-icon nc-email-85',
    path: '/sugerencias/gestion',
    requireSupport: false
  },
  {
    name: 'Ventas',
    icon: 'nc-icon nc-money-coins',
    children: [
      {
        name: "Ventas de Sucursales",
        path: "/sales/gym"
      },
      {
        name: 'Ventas por Internet',
        path: '/sales/online'
      },
      {
        name: 'Cierres de Caja',
        path: '/sales/cash-closing'
      }
    ],
    requireSupport: false
  },
  // Menú "Herramientas" oculto desde 0.8.14 — son experimentaciones (Email Constructor,
  // Conectores API, WhatsApp Web) que aún no están listas para producción. Las rutas
  // /tools/* siguen registradas en routes.js para continuar el desarrollo.
  // {
  //   name: 'Herramientas',
  //   icon: 'nc-icon nc-settings-gear-65',
  //   children: [
  //     {
  //       name: 'Email Constructor',
  //       path: '/tools/email-builder'
  //     },
  //     {
  //       name: 'Conectores API',
  //       path: '/tools/conectores-api'
  //     },
  //     {
  //       name: 'WhatsApp Web',
  //       path: '/tools/whatsapp-web'
  //     }
  //   ],
  //   requireSupport: false
  // },
  {
    name: 'Descargas',
    icon: 'nc-icon nc-cloud-download-93',
    path: '/downloads/win',
    requireSupport: false,
  },
  {
    name: 'Configuraciones',
    icon: 'nc-icon nc-settings-gear-65',
    path: '/settings',
    requireSupport: false,
    children: [
      {
        name: 'Puntos de Venta',
        path: '/settings/POS'
      },
      // Sub-entrada visible sólo para perfil SOPORTE (filtrado en DashboardLayout.vue
      // mediante `requireSupport: true`, que ahora se aplica también a children).
      // La condición previa de BUILD_MODE se mantiene para no exponerla en producción
      // a usuarios SOPORTE que aún no la necesitan ahí.
      ...(showAccessPoints ? [{
        name: 'Puntos de Acceso',
        path: '/settings/AP',
        requireSupport: true
      }] : []),
      {
        name: 'Proc. Automáticos',
        path: '/settings/ProcesosAutomaticos'
      }
    ]
  },
  {
    name: 'Pages',
    icon: 'nc-icon nc-book-bookmark',
    children: [
      {
        name: 'Timeline',
        path: '/pages/timeline'
      },
      {
        name: 'User Profile',
        path: '/pages/user'
      },
      {
        name: 'Login',
        path: '/login'
      },
      {
        name: 'Register',
        path: '/register'
      },
      {
        name: 'Lock',
        path: '/lock'
      }
    ],
    requireSupport: true
  },
  {
    name: 'Components',
    icon: 'nc-icon nc-layout-11',
    children: [{
      name: 'Buttons',
      path: '/components/buttons'
    },
    {
      name: 'Grid System',
      path: '/components/grid-system'
    },
    {
      name: 'Panels',
      path: '/components/panels'
    },
    {
      name: 'Sweet Alert',
      path: '/components/sweet-alert'
    },
    {
      name: 'Notifications',
      path: '/components/notifications'
    },
    {
      name: 'Icons',
      path: '/components/icons'
    },
    {
      name: 'Typography',
      path: '/components/typography'
    }],
    requireSupport: true
  },
  {
    name: 'Forms',
    icon: 'nc-icon nc-ruler-pencil',
    children: [{
      name: 'Regular Forms',
      path: '/forms/regular'
    },
    {
      name: 'Extended Forms',
      path: '/forms/extended'
    },
    {
      name: 'Validation Forms',
      path: '/forms/validation'
    },
    {
      name: 'Wizard',
      path: '/forms/wizard'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Table List',
    icon: 'nc-icon nc-single-copy-04',
    collapsed: true,
    children: [{
      name: 'Regular Tables',
      path: '/table-list/regular'
    },
    {
      name: 'Extended Tables',
      path: '/table-list/extended'
    },
    {
      name: 'Paginated Tables',
      path: '/table-list/paginated'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Maps',
    icon: 'nc-icon nc-pin-3',
    children: [{
      name: 'Google Maps',
      path: '/maps/google'
    },
    {
      name: 'Full Screen Maps',
      path: '/maps/full-screen'
    },
    {
      name: 'Vector Maps',
      path: '/maps/vector-map'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Widgets',
    icon: 'nc-icon nc-box',
    path: '/admin/widgets',
    requireSupport: true
  },
  {
    name: 'Charts',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/charts',
    requireSupport: true
  },
  {
    name: 'Calendar',
    icon: 'nc-icon nc-calendar-60',
    path: '/calendar',
    requireSupport: true
  },
  // Registro de Cambios — siempre al final del sidebar, visible para todos los perfiles.
  {
    name: 'Registro de Cambios',
    icon: 'nc-icon nc-single-copy-04',
    path: '/registro-cambios/historial',
    requireSupport: false
  },
]
